import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _17mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"17mp"}/>
}
